import React, { useEffect } from 'react';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import imgBackground from '../../assets/congratulations/img-background.png';

import { Container, Informations } from './_mentorshipThankPage';

export const MentorshipThankPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <Header />
      <div>
        <Informations>
          <div>
            <h1>Parabéns</h1>
            <p>
              Nós somos muito gratos por você estar aqui. É um prazer imenso
              poder te guiar nessa jornada e te mostrar o poder que o yoga tem
              de transformar e mudar nossas vidas para melhor.
            </p>
            <span>
              DO MEU CORAÇÃO <br /> PARA O SEU
            </span>
            <span>Worsheep</span>
          </div>
        </Informations>
        <img
          src={imgBackground}
          alt="Imagem da Priscila com a camisa do YouMaster"
        />
      </div>
      <Footer />
    </Container>
  );
};
